{
	"address-search": {
		"address-search": "Götuskrá",
		"address-search-placeholder": "Leitaðu af götuheiti",
		"info-text": "Athugið að tölur byggja á gögnum frá Byggðastofnun og Pósturinn getur ekki ábyrgst að þessar upplýsingar séu réttar.",
		"place": "Sveitarfélag",
		"road": "Gata",
		"search": "Leita"
	},
	"homes-and-companies": {
		"companies": "Fyrirtæki",
		"homes": "Heimili",
		"homes-and-companies": "Heimili og fyrirtæki",
		"place": "Póststöð",
		"postcode": "PNR."
	},
	"letter-postbox": {
		"address": "Heimilisfang",
		"letter-postbox": "Póstbox",
		"letter-postboxes": "Póstkassar",
		"name": "Nafn",
		"zip": "Póstnúmer"
	},
	"mapcover": "Íslandskort: Póstnúmera þekja",
	"mapcover-duratation": "Gildir frá 1. október 2019.",
	"mapcover-move": "Hægt er að þysja kortið út til að sjá heildarskiptingu póstnúmera yfir allt landið.",
	"noresult": "Leitin skilaði engum niðurstöðum",
	"service-level": {
		"company-service": "Fyrirtækjaþjónusta",
		"home-delivery-companies": "Heimkeyrsla fyrirtækja",
		"home-delivery-individual": "Heimkeyrsla einstaklinga",
		"last-safe-dropoff-time": "Síðasti öruggi skilatími",
		"opening-hours": "Afgreiðslutími",
		"partner": "Samstarfsaðili",
		"place": "Staður",
		"postoffice": "Pósthús",
		"see-more": "Sjá meira",
		"service": "Þjónusta",
		"service-level": "Þjónustustig",
		"service-level-table": "Þjónustustig tafla",
		"service-postoffice": "Þjónustupósthús"
	}
}
